module.exports = __webpack_public_path__ + "img/hapi.6ca3657f.png";